import { state_ctrl_factory_method } from 'ww2_analytics/common/state_ctrl';

const main_view = {
    template: require('./view.html'),
    controller: state_ctrl_factory_method('retention.get_total_install_count', function($scope, resp) {
        $scope.vm.total_install_count = resp;
    }),
};
const state_config = {
    url: '/short',
    reloadOnSearch: false,
    data: {
        priority: 886,
        title: 'Short V1',
    },
    views: {
        '': main_view,
    },
};
export default state_config;
